/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Wry_Wide_Snail_DashInputs */

const en_wry_wide_snail_dash = /** @type {(inputs: Wry_Wide_Snail_DashInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Provide contact details for user identification and communication. Either email address or username is required to create the member.`)
};

const de_wry_wide_snail_dash = /** @type {(inputs: Wry_Wide_Snail_DashInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Geben Sie Kontaktdaten für die Benutzeridentifikation und Kommunikation an. Entweder E-Mail-Adresse oder Personalnummer ist erforderlich.`)
};

/**
* | output |
* | --- |
* | "Provide contact details for user identification and communication. Either email address or username is required to create the member." |
*
* @param {Wry_Wide_Snail_DashInputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
export const wry_wide_snail_dash = /** @type {((inputs?: Wry_Wide_Snail_DashInputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Wry_Wide_Snail_DashInputs, { locale?: "en" | "de" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_wry_wide_snail_dash(inputs)
	return de_wry_wide_snail_dash(inputs)
});